var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "div",
      staticClass: "ys-float-btn",
      style: {
        width: _vm.itemWidth + "px",
        height: _vm.itemHeight + "px",
        left: _vm.left + "px",
        top: _vm.top + "px",
      },
    },
    [
      _vm.loading
        ? _c("el-button", {
            style: {
              width: _vm.itemWidth + "px",
              height: _vm.itemHeight + "px",
            },
            attrs: {
              disabled: _vm.loading,
              loading: _vm.loading,
              circle: "",
              plain: "",
              type: "primary",
            },
            on: { click: _vm.onBtnClicked },
          })
        : _c(
            "el-button",
            {
              style: {
                width: _vm.itemWidth + "px",
                height: _vm.itemHeight + "px",
              },
              attrs: {
                disabled: _vm.loading,
                loading: _vm.loading,
                circle: "",
                plain: "",
                type: "primary",
              },
              on: { click: _vm.onBtnClicked },
            },
            [_vm._v("\n\t\t\t" + _vm._s(_vm.text) + "\n\t\t")]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }